import { render, staticRenderFns } from "./MonitorTableItem.vue?vue&type=template&id=190df562&scoped=true"
import script from "./MonitorTableItem.vue?vue&type=script&lang=js"
export * from "./MonitorTableItem.vue?vue&type=script&lang=js"
import style0 from "./MonitorTableItem.vue?vue&type=style&index=0&id=190df562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190df562",
  null
  
)

export default component.exports